
import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CompareStatsModal = ({ entry1, entry2, onClose, viewType }) => {
  const { t } = useTranslation();
  if (!entry1 || !entry2) return null;

  const getStatLabel = (type) => {
    switch (type) {
      case 'reputation': return t('compareStatsModal.reputation');
      case 'earnings': return t('compareStatsModal.echoesEarned');
      case 'whispers': return t('compareStatsModal.whispersPosted');
      case 'moments': return t('compareStatsModal.momentsCreated');
      case 'quests': return t('compareStatsModal.questsCompleted');
      case 'nexus_souls': return t('compareStatsModal.totalSouls');
      default: return t('compareStatsModal.value');
    }
  };

  const statLabel = getStatLabel(viewType);

  return (
    <div className="modal-overlay animate-fadeIn">
      <div className="bg-gray-900/90 backdrop-blur-md p-6 rounded-xl border border-indigo-500/50 shadow-2xl max-w-2xl w-full relative animate-zoomIn">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-white transition-colors">
          <LucideIcons.X size={24} />
        </button>
        <h3 className="text-2xl font-bold text-indigo-300 text-center mb-6 font-playfair">{t('compareStatsModal.title')}</h3>
        
        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col items-center p-4 bg-gray-800/70 rounded-lg border border-indigo-400/50">
            <img src={entry1.photoURL || entry1.emblemUrl || "https://placehold.co/60x60/AEC6CF/FFFFFF?text=U"} alt={entry1.displayName || entry1.name} className="w-16 h-16 rounded-full object-cover mb-2" />
            <p className="font-bold text-white text-lg">{entry1.displayName || entry1.name}</p>
            <p className="text-sm text-gray-400">{t('compareStatsModal.rank', { rank: entry1.rank + 1 })}</p>
            <div className="mt-4 text-center">
              <p className="text-xl font-bold text-cyan-300">{entry1.value?.toLocaleString()}</p>
              <p className="text-xs text-gray-500">{statLabel}</p>
            </div>
          </div>

          <div className="flex flex-col items-center p-4 bg-gray-800/70 rounded-lg border border-indigo-400/50">
            <img src={entry2.photoURL || entry2.emblemUrl || "https://placehold.co/60x60/AEC6CF/FFFFFF?text=U"} alt={entry2.displayName || entry2.name} className="w-16 h-16 rounded-full object-cover mb-2" />
            <p className="font-bold text-white text-lg">{entry2.displayName || entry2.name}</p>
            <p className="text-sm text-gray-400">{t('compareStatsModal.rank', { rank: entry2.rank + 1 })}</p>
            <div className="mt-4 text-center">
              <p className="text-xl font-bold text-cyan-300">{entry2.value?.toLocaleString()}</p>
              <p className="text-xs text-gray-500">{statLabel}</p>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <button onClick={onClose} className="px-6 py-2 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 transition-colors">
            {t('compareStatsModal.close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompareStatsModal;
